import React, { useState } from 'react';
import { QRCodeCanvas } from 'qrcode.react'; // Import the correct export

const QrCodeGenerator = () => {
    const [inputText, setInputText] = useState(''); // State to hold input text
    const [qrValue, setQrValue] = useState(''); // State to hold the QR code value

    const handleInputChange = (e) => {
        setInputText(e.target.value); // Update input text
    };

    const generateQrCode = () => {
        setQrValue(inputText); // Set the QR value based on input
    };

    return (
        <div style={{ textAlign: 'center', padding: '20px' }}>
            <h1>QR Code Generator</h1>
            <div>
                <input
                    type="text"
                    value={inputText}
                    onChange={handleInputChange}
                    placeholder="Enter text to generate QR code"
                    style={{ padding: '10px', width: '70%', fontSize: '16px' }}
                />
                <button
                    onClick={generateQrCode}
                    style={{
                        marginLeft: '10px',
                        padding: '10px 20px',
                        fontSize: '16px',
                        backgroundColor: 'blue',
                        color: 'white',
                        border: 'none',
                        cursor: 'pointer',
                    }}
                >
                    Generate QR Code
                </button>
            </div>

            {/* Display QR Code */}
            {qrValue && (
                <div style={{ marginTop: '20px' }}>
                    <h3>Generated QR Code:</h3>
                    <QRCodeCanvas value={qrValue} size={256} />
                    <p style={{ marginTop: '10px' }}>Value: {qrValue}</p>
                </div>
            )}
        </div>
    );
};

export default QrCodeGenerator;
